export default __webpack_public_path__ + "static/media/padel-league-thumbnail.02b8a7f9.png";